/*
 * File: ReferralCard.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles referral data in the MUI card component
 */
/**
 */
import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  referrerData: {
    marginTop: theme.spacing(3.5)
  },
  toolbar: {
    display: "block",
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2.5)
  }
});

const ReferralCard = ({ classes, referral }) => (
  <React.Fragment>
    <div className={classes.toolbar}>
      <MainHeader
        pageTitle={referral.first + " " + referral.last}
        pageSubtitle="Referrers"
      />

      <div className={classes.referrerData}>
        <Typography className={classes.body1} variant="body1">
          <b>Type:</b> {referral.type}
        </Typography>
        <Typography variant="body1">
          <b>Default Specialty:</b> {referral.specialty}
        </Typography>
        <Typography variant="body1">
          <b>NPI:</b> {referral.npi}
        </Typography>
      </div>
    </div>
  </React.Fragment>
);

ReferralCard.propTypes = {
  classes: PropTypes.object.isRequired,
  referral: PropTypes.object.isRequired
};

export default withStyles(styles)(ReferralCard);
